module.exports = {"id":"183568","name":"Sebastian Langkamp","rating":"77","photo":"./data/images/photos/3/183568.png","club":{"name":"Werder Brême","logo":"./data/images/clubs/WerderBreme.png"},"positions":["DC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/SebastianLangkamp0.json
// module id = 3862
// module chunks = 0